import React from 'react'

interface IProps {
  primary?: boolean
  secondary?: boolean
  tertiary?: boolean
  danger?: boolean
  children: string
  className?: string
  isLoading?: boolean
  onClick?: () => void
}

const Button: React.FC<IProps> = ({
  className = '',
  primary,
  secondary,
  tertiary,
  danger,
  children,
  isLoading,
  onClick,
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  let classNames = 'btn'

  if (primary) {
    classNames += ' btn-primary'
  }
  if (secondary) {
    classNames += ' btn-secondary'
  }
  if (tertiary) {
    classNames += ' btn-tertiary'
  }
  if (danger) {
    if (secondary) {
      classNames += ' btn-secondary-danger'
    } else {
      classNames += ' btn-danger'
    }
  }

  return (
    <button
      onClick={handleClick}
      className={`${className} ${classNames} ${isLoading && 'btn-loading'}`}
    >
      {isLoading ? (
        <div style={{ left: '50%', transform: 'translateX(-50%)' }} className="absolute">
          <div className="loader loader--white loader--small" />
        </div>
      ) : null}
      <span className={`${isLoading ? 'invisible' : ''}`}>{children}</span>
    </button>
  )
}

export default Button
